<template>
  <div>
    <common-dialog
      ref="dialog"
      width="750px"
      :show-save-button="false"
      unit="教育教学科研成果奖"
      id-key="ClassId"
      :data="data"
      form-label-width="95px"
      :form-rules="rules"
      :save-func="api.save"
      :before-save="onBeforeSave"
      :get-data-func="data.AutoType==0?api.info:api.getAutoInfo"
      @edit-opened="onEditOpened"
      @create-opened="onCreateOpened"
      @close="closeFun"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="isMB?24:12">
            <el-form-item label="姓名" prop="TeacherName">
              <el-input
                size="mini"
                v-model="data.TeacherName"
                @focus="onTeacherDialog"
                readonly
                placeholder="点击选择"
                v-if="$permission.canAll(path) && !check"
              ></el-input>
              <span v-else>{{data.TeacherName}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="奖项名称" prop="EduResultName">
              <el-input size="mini" v-model="data.EduResultName"  placeholder="请填写奖项名称" v-if="!check"></el-input>
              <span v-else>{{data.EduResultName}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="获得时间" prop="GetDate">
                    <el-date-picker
                      size="mini"
                      v-model.trim="data.GetDate"
                      placeholder="请选择日期"
                      value-format="yyyy-MM-dd"
                      style="width:100%;"
                      v-if="!check"
                    ></el-date-picker>
                    <span v-else>{{$commonJs.toDateString(data.GetDate)}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="类别" prop="GdCategory">
              <el-select v-model="data.GdCategory" clearable size="mini" style="width:100%;" v-if="!check">
                   <el-option
                        v-for="item in CategoryList"
                        :value="item.DataName"
                        :label="item.DataName"
                        :key="item.DataName"
                   ></el-option>
              </el-select>
              <span v-else>{{data.GdCategory}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="级别" prop="GdLv">
              <el-select v-model="data.GdLv" clearable size="mini" style="width:100%;" v-if="!check">
                   <el-option
                        v-for="item in ThemeLvList"
                        :value="item.DataName"
                        :label="item.DataName"
                        :key="item.DataName"
                   ></el-option>
              </el-select>
              <span v-else>{{data.GdLv}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="等次" prop="GdGrade">
              <el-select v-model="data.GdGrade" clearable size="mini" style="width:100%;" v-if="!check">
                   <el-option
                        v-for="item in GradeList"
                        :value="item.DataName"
                        :label="item.DataName"
                        :key="item.DataName"
                   ></el-option>
              </el-select>
              <span v-else>{{data.GdGrade}}</span>
            </el-form-item>
          </el-col>
         <el-col :span="isMB?24:12">
            <el-form-item label="主办单位" prop="Organizer">
              <el-input size="mini" v-model="data.Organizer" v-if="!check"  placeholder="请填写主办单位"></el-input>
              <span v-else>{{data.Organizer}}</span>
            </el-form-item>
         </el-col>
         <el-col :span="isMB?24:12">
            <el-form-item label="本人角色" prop="Role">
              <el-select v-model="data.Role" clearable size="mini" style="width:100%;" v-if="!check">
                  <el-option value="主持人" label="主持人"></el-option>
              </el-select>
              <span v-else>{{data.Role}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label=" 证明附件" prop="CertUrl">
            <import-file
              :upload-url="api.UploadFileUrl"
              :subData="subData"
              text="上传附件"
              w="150px"
              :disabled="check"
              :btntype="!check"
              single
              @on-uploaded="uploaded"
              :uploadFiles="uploadedFiles"
            />
            </el-form-item>
          </el-col>
       <dialog-list :showTax="data.ShowTax" ref="dialogList" :info="data" :readonly="check"/>
        </el-row>
      </template>
      <template slot="footer">
        <el-button size="mini" type="primary" @click="examineDiary" v-if="isOpen">审批日志</el-button>
        <el-button size="mini" type="primary" @click="diaryEdit" v-if="isOpen">修改日志</el-button>
        <el-button size="mini" type="success" v-if="!isEdit && !check" @click="()=>{save()}">保存</el-button>
        <el-button size="mini" type="primary" v-if="(data.Status==0 || data.Status==2) && !check" @click="()=>{Submit()}">提交</el-button>
        <el-button size="mini" type="primary" @click="examine" v-if="isEdit">通过</el-button>
        <el-button size="mini" type="danger" @click="cancelExamine" v-if="isEdit">退回</el-button>
        <el-button size="mini" @click="close" >关 闭</el-button>
      </template>
    </common-dialog>
      <teacher-dialog
        ref="teacherDialog"
        in-dialog
        selectable
        :multiple="false"
        @select="setTeacher"
      />
      <details-dialog ref="detailsDialog" @close-saved="()=>{$emit('close-saved'),save(),close(1)}"></details-dialog>
      <diary-dialog ref="diaryDialog" @close-saved="()=>{$emit('diary-saved'),close(1)}"></diary-dialog>
       <examine-dialog ref="examineDialog" @close-saved="()=>{$emit('diary-saved'),close(1)}"></examine-dialog>
  </div>
</template>
<script>
import dialogList from "./dialogList";
import examineDialog from "@/components/gd/scientific/list4/examineDialog";
import diaryDialog from "@/components/gd/scientific/list4/diaryDialog";
import detailsDialog from "@/components/gd/scientific/list4/detailsDialog";
import teacherDialog from "@/components/fa/teacher/listDialog";
import importFile from "@/components/common/files/importFile";
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import termApi from "@/api/ed/term";
import router from '@/router'
let loginInfo = JSON.parse(localStorage.getItem("loginInfo"));

export default {
  props: {
    ThemeLvList: {
      type: Array,
      default: [],
    },
    CategoryList: {
      type: Array,
      default: [],
    },
    GradeList: {
      type: Array,
      default: [],
    },
  },
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    importFile,
    teacherDialog,
    detailsDialog,
    diaryDialog,
    examineDialog,
    dialogList
  },
  data() {
    return {
      path:router.history.current.path,
      data: {
        AutoType:0,
        EduResultId:0,
        TeacherId:JSON.parse(localStorage.getItem("loginInfo")).TeacherId,
        TeacherName:JSON.parse(localStorage.getItem("loginInfo")).UserName,    
        EduResultName: "",
        GetDate: "",
        FinishDate: "",
        GdCategory: "",
        GdLv: "",
        GdGrade:"",
        CertUrl: "",
        CertName:"",
        Status:0,
        Role:"主持人",
        Members:"",
        Organizer:"",
      },
      uploadedFiles:[],
      files:[],
      subData: {
        dic: 'Gd',
      },
      api: require("@/api/gd/eduresult").default,
      Base_api: require("@/api/gd/basedata").default,
      gradeApi: require("@/api/ed/grade").default,
      termApi,
      isMB: this.$store.state.isMB,
      // gradeList: [],
      termList: [],
      isEdit: false,
      isOpen:false,
      check:false,
      rules: {
        TeacherName: [{ required: true, message: "请选择人员" }],
        EduResultName: [{ required: true, message: "请输入奖项名称" }],
        GetDate: [{ required: true, message: "请选择获得时间" }],
        GdCategory: [{ required: true, message: "请选择类别" }],
        GdLv: [{ required: true, message: "请选择级别" }],
        GdGrade: [{ required: true, message: "请选择等次" }],
        Organizer: [{ required: true, message: "请填写主办单位" }],
        Role: [{ required: true, message: "请选择角色" }],
        CertUrl: [{ required: true, message: "请上传附件" }],
      },
    };
  },
  computed: {},
  methods: {
      closeFun(){
       this.uploadedFiles=[]
      },
      onBeforeSave() {
       console.log(this.$refs.dialogList.tableData)
      let tableData = this.$refs.dialogList.tableData;
      let tableDel = this.$refs.dialogList.tableDel;
      let tb = []
      // if(tableData.length==0 || !tableData.some(v=>v.GoodsId)) {
      //   this.$message.error("请填写课题成员");
      //   return false;
      // }
      for(var i = 0; i < tableData.length; i++) {
        if(!tableData[i].TeacherId) {
          this.$message.error("请填写成员名称");
          return false;
        }
        if(!tableData[i].Role) {
          this.$message.error("请填写角色");
          return false;
        }
        if(tableData[i].T===0||tableData[i].T===1) {
          console.log(tableData[i].T)
          tb.push(tableData[i])
        }
        
      }
      this.data.Members = tb.concat(tableDel)

      console.log('data',this.data)
      return true
    },
    createStateFilter(queryString) {
      return (state) => {
        return (state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    examineDiary(){
       this.$refs.examineDialog.openEdit({RecordId:this.data.EduResultId,MenuName:'教育教学科研成果奖管理',Gd:true});
    },
    diaryEdit(){
       this.$refs.diaryDialog.openEdit({RecordId:this.data.EduResultId,MenuName:'教育教学科研成果奖管理'});
    },
    Submit(){
      this.$refs.dialog.formValidate().then((valid) => {
          if (!valid) {
            return;
          }
        this.onBeforeSave()
        this.$refs.dialog.isLoading = true;
        this.api.submit(this.data).then(res => {
          this.$refs.dialog.isLoading = false;
          if(res.Code ==0) {
            this.$message.success(res.Msg)
            this.readonly = true
            this.close(1)
            this.$emit("close-saved")
          } else {
            this.$message.error(res.Msg)
          }
        })
      })
    },
        examine() {
      this.$confirm("确认通过吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
      .then(() => {
        this.save()
        this.api.examine(this.data.EduResultId).then(res => {
          if(res.Code ==0) {
            this.$message.success(res.Msg)
            this.readonly = true
            this.close(1)
            this.$emit("close-saved")
          } else {
            this.$message.error(res.Msg)
          }
        })
      })
    },
    cancelExamine() {
      sessionStorage.setItem('cancel','3')
      this.$refs.detailsDialog.openEditById({id:this.data.EduResultId});
    },
    // cancelExamine() {
    //   this.$confirm("确认退回吗？", "提示", {
    //     confirmButtonText: "确定",
    //     cancelButtonText: "取消",
    //     type: "warning",
    //   })
    //   .then(() => {
    //     this.api.cancelExamine(this.data.EduResultId).then(res => {
    //       if(res.Code ==0) {
    //         this.$message.success(res.Msg)
    //         this.readonly = false
    //         this.close()
    //         this.$emit("close-saved")
    //       } else {
    //         this.$message.error(res.Msg)
    //       }
    //     })
    //   })
    // },
    setTeacher(t) {
      this.data.TeacherId = t.TeacherId;
      this.data.TeacherName = t.TeacherName;
    },
    onTeacherDialog() {
      this.$refs.teacherDialog.open().then((that) => {
        that.getData();
      });
    },
    uploaded(res, fileList) {
      console.log("uploaded", res, fileList);
      this.fileList = fileList;
      this.data.CertUrl=res.Data.VirtualPath
      this.data.CertName=res.Data.FileName+'.'+res.Data.Extension
    },
    onCreateOpened() {
      this.isEdit = false;
      this.isOpen=false;
      this.check = false;
      this.$refs.dialogList.tableData = []
      // this.data.TermId = loginInfo.TermId;
      // this.getOption()
    },
    onEditOpened(row) {
      this.isOpen=true
      if(sessionStorage.getItem('check')==='1') {
        this.isEdit = true;
        this.check = false;
        sessionStorage.removeItem('check')
      }else if(sessionStorage.getItem('check')==='2') {
        this.isEdit = false;
        this.check = true;
        sessionStorage.removeItem('check')
      }  else {
        this.check = false;
        this.isEdit = false;
      }
      this.$refs.dialogList.tableDel = []
      this.$refs.dialogList.getData()
      if(this.data.CertUrl){
      this.uploadedFiles=[{
              name: this.data.CertName,
              url: location.protocol + "//" + location.host +'/api'+ this.data.CertUrl,
            }]
      }
    },

  },
};
</script>
<style lang="scss">
</style>